const FNV_OFFSET = 2166136261;
const FNV_PRIME = 16777619;

function fnv1a32(s: string, fromEnd = false): number {
	let hash = FNV_OFFSET;

	if (fromEnd) {
		for (let i = s.length - 1; i >= 0; i -= 1) {
			hash ^= s.charCodeAt(i);
			hash = Math.imul(hash, FNV_PRIME);
		}
	} else {
		for (let i = 0; i < s.length; i += 1) {
			hash ^= s.charCodeAt(i);
			hash = Math.imul(hash, FNV_PRIME);
		}
	}

	return hash >>> 0;
}

/** Deterministic non-crypto hash — fixed 16-char hex for analytics fingerprints. */
export function deterministicStringHash(s: string): string {
	const h1 = fnv1a32(s).toString(16).padStart(8, "0");
	const h2 = fnv1a32(s, true).toString(16).padStart(8, "0");

	return `${h1}${h2}`;
}
